import { SalesOrderStatus } from '../constants/sales-order-status.js';
export const SalesOrderLineEditApprovalOutcome = {
    NONE: 'NONE',
    SELF_APPROVED: 'SELF_APPROVED',
    REAPPROVAL: 'REAPPROVAL',
    BLOCKED: 'BLOCKED',
};
// A Draft hasn't been approved yet, and an order awaiting approval is about to be looked at anyway.
const NOT_YET_APPROVED = new Set([
    SalesOrderStatus.DRAFT,
    SalesOrderStatus.AWAITING_APPROVAL,
]);
/** ML-7 to ML-10: a Submitted Standard order without a pick and with a run idle at Submitted goes back through approval (ML-8); every other order an editor can't approve for is refused. */
export function lineEditApprovalOutcome(args) {
    if (NOT_YET_APPROVED.has(args.statusId) || args.newlyTripped.length === 0) {
        return SalesOrderLineEditApprovalOutcome.NONE;
    }
    if (args.canApprove)
        return SalesOrderLineEditApprovalOutcome.SELF_APPROVED;
    if (args.statusId === SalesOrderStatus.SUBMITTED &&
        !args.pickExists &&
        !args.decisionPending &&
        args.orderPath === 'Standard' &&
        args.runAcceptsSendBack) {
        return SalesOrderLineEditApprovalOutcome.REAPPROVAL;
    }
    return SalesOrderLineEditApprovalOutcome.BLOCKED;
}
//# sourceMappingURL=line-edit-approval-outcome.js.map